import { getTopTenCustomers } from "@/services";
import { useQuery } from "react-query";

export const useGetTopTenCustomersData = () => {
 const { data: topTenCustomers, isLoading: getTopTenCustomersIsLoading } =
  useQuery("topTenCustomers", getTopTenCustomers);
 return { topTenCustomers, getTopTenCustomersIsLoading };
};
